export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="bg-[#EAE7DF] border-y border-[#D5D1C8] py-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { label: "Built for farmers & service providers", value: "Designed in mind" },
            { label: "Dairy & Beef", value: "Both ready" },
            { label: "Provider neutral", value: "Bring your data" },
            { label: "Works offline", value: "No coverage? Fine." },
          ].map((b) => (
            <div
              key={b.label}
              data-testid={`trust-${b.label.toLowerCase().replace(/\s/g, "-")}`}
              className="border-x border-[#D5D1C8] first:border-l-0 last:border-r-0 px-2"
            >
              <p className="font-display font-bold text-lg sm:text-xl text-[#1A1D1A]">
                {b.value}
              </p>
              <p className="mt-1 text-xs uppercase tracking-wider text-[#4A4F4A] font-semibold">
                {b.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
